import authorization from './authorization.gql';
import notification from './notification.gql';
import categories from './categories.gql';
import users from './users.gql';

export default { ...authorization, ...notification, ...categories, ...users };
